import axios from 'axios';
import {
  CREATE_FORM_SECTION_URL,
  GET_FORM_STRUCTURE_URL,
  GET_ALL_MAIN_SECTIONS_URL,
  GET_ALL_SECTIONS_CATALOG_URL,
  CREATE_MAIN_SECTION_URL,
  DELETE_MAIN_SECTION_URL,
  GET_MAIN_SECTIONS_BY_FORM_URL,
  REORDER_FORM_SECTION_URL,
  REORDER_MAIN_SECTIONS_URL,
  SOFT_DELETE_FORM_SECTION_URL,
  UPDATE_MAIN_SECTION_URL,
  get_request_config,
} from '@/utils/system_constants/constant.js';
import {
  extract_items,
  parse_response_data,
} from '@/utils/api_response_helpers';

export const create_main_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(CREATE_MAIN_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const fetch_main_sections_by_form = async (form_id) => {
  const request_config = get_request_config({
    params: {
      form_id,
    },
  });
  const response = await axios.get(GET_MAIN_SECTIONS_BY_FORM_URL, request_config);

  return extract_items(response);
};

export const create_sub_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(CREATE_FORM_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const fetch_all_main_sections = async () => {
  const request_config = get_request_config();
  const response = await axios.get(GET_ALL_MAIN_SECTIONS_URL, request_config);

  return extract_items(response);
};

export const fetch_all_sections_catalog = async () => {
  const request_config = get_request_config();
  const response = await axios.get(GET_ALL_SECTIONS_CATALOG_URL, request_config);

  return extract_items(response);
};

export const soft_delete_form_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(SOFT_DELETE_FORM_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const reorder_main_sections = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(REORDER_MAIN_SECTIONS_URL, payload, request_config);

  return parse_response_data(response);
};

export const update_main_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(UPDATE_MAIN_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const delete_main_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(DELETE_MAIN_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const reorder_form_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(REORDER_FORM_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const fetch_form_structure = async (form_id) => {
  const request_config = get_request_config({
    params: {
      form_id,
    },
  });
  const response = await axios.get(GET_FORM_STRUCTURE_URL, request_config);

  return extract_items(response);
};
